export default __webpack_public_path__ + "static/media/user-round.13b5a31b.svg";